/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DisplayOption {
    TWO_PER_ROW = 'TwoPerRow',
    FULL_PAGE = 'FullPage',
}
